import React from "react";

function Shield() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="44"
            height="44"
            fill="none"
            viewBox="0 0 44 44"
        >
            <path
                stroke="#DF8D46"
                strokeDasharray="10 10"
                strokeWidth="2"
                d="M1 1H43V43H1z"
            ></path>
            <path
                fill="#DF8D46"
                d="M15.998 28.048c-1.512-1.516-1.798-3.072-1.798-3.072l-.04-10.236L22 12.2l7.84 2.54-.042 10.236s-.286 1.554-1.796 3.07c-1.39 1.398-5.344 3.404-5.962 3.714a2.27 2.27 0 01-.082.04c-.616-.348-4.57-2.356-5.96-3.752z"
            ></path>
            <path
                fill="#DF8D46"
                d="M17.59 22l3.208 3.43 5.612-6.86L17.59 22z"
            ></path>
        </svg>
    );
}

export default Shield;
